// extracted by mini-css-extract-plugin
module.exports = {"setContent":"_1-Vv7","customRow":"C7tbs","customCol":"_3kV4n","listCol":"_1K9-l","viewButton":"_2EiDW","moreButton":"_2l5zt"};